import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EnvironmentFormComponent } from '../environment-form/environment-form.component';
import { LoaderService } from '../../../shared/services/loader.service';
import { EnvironmentService } from '../environment.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-environment',
  standalone: true,
  imports: [CommonModule, EnvironmentFormComponent],
  templateUrl: './edit-environment.component.html',
  styleUrls: ['./edit-environment.component.scss']
})
export class EditEnvironmentComponent {
  loading: boolean;
  /** The environment object to be edited, passed as input */
  @Input() environment: any = null;
  /** Emits the updated environment form value when submitted (must include id) */
  @Output() environmentFormSubmitted = new EventEmitter<any>();
  /** Emits when the edit action is cancelled */
  @Output() editCancelled = new EventEmitter<void>();
  // @Output("closeSlider") closeSlider: EventEmitter<any> = new EventEmitter();
  constructor(private readonly loaderService: LoaderService,
    private readonly environmentService: EnvironmentService,
    private readonly toastr: ToastrService) {

  }
  closeEdit() {
      this.editCancelled.emit();
  }

  /**
   * Handles the form submit event and emits the updated environment (with id).
   * @param updatedFormValue The updated environment form value (must include id)
   */
  handleFormSubmit(updatedFormValue: any) {
    // Ensure id is present for update
    if (!updatedFormValue.id && this.environment && this.environment.id) {
      updatedFormValue.id = this.environment.id;
    }
    // Build update payload with all required fields, similar to add flow
    const updatedEnvironment = {
      id: updatedFormValue.id || undefined,
      environmentName: updatedFormValue.environmentName,
      environmentType: updatedFormValue.environmentType,
      workflowName: updatedFormValue.workflowName,
      status: updatedFormValue.isActive ? 'Active' : 'Inactive',
      services: (updatedFormValue.services as any[])
        .filter((service: any) => service.selected)
        .map((service: any, index: number) => {
          return {
            serviceId: service.serviceId,
            serviceName: service.serviceName || service.name || `Service ${index + 1}`,
            hasAPI: Boolean(service.hasAPI),
            hasWeb: Boolean(service.hasWeb),
            apiUrl: service.apiUrl === '' ? null : service.apiUrl,
            webUrl: service.webUrl === '' ? null : service.webUrl,
            isSelected: service.selected
          };
        }),
    };
    this.setLoader();
    this.environmentService.updateEnvironment(updatedEnvironment).subscribe({
      next: () => {
        this.toastr.success('Environment updated successfully!');
        this.environmentFormSubmitted.emit();
        this.setUnLoader();
      },
      error: () => {
        this.environmentFormSubmitted.emit();
        this.setUnLoader();
      }
    });
  }

  setLoader() {
    this.loading = true;
    this.loaderService.showSpinner.next(true);
  }
  setUnLoader() {
    this.loading = false;
    this.loaderService.showSpinner.next(false);
  }
} 
